import Vue from "vue";
import App from "./App";
import FetchData from "vue-fetch-data";
import VueRouter from "vue-router";
import router from "@/routes/routes.js";
import { store } from "@/store/store.js";
import { sync } from "vuex-router-sync";
import axios from "axios";
import VueAxios from "vue-axios";
import VueAwesomeSwiper from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "@/assets/css/fonts.css";
import "@/assets/css/font-awesome.min.css";
import "@/assets/css/style.css";
import "@/assets/css/mobile.css"
import VTooltip from "v-tooltip";
import VueBraintree from "vue-braintree";
import { Stripe } from "stripe"
import firebase from "firebase";
import { StripePlugin } from '@vue-stripe/vue-stripe';
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import VueMeta from 'vue-meta'

Vue.use(VueMeta)
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)

Vue.use(VTooltip);
Vue.use(VueAwesomeSwiper /* { default options with global component } */ );
Vue.use(VueAxios, axios);
Vue.use(VueRouter);
Vue.use(VueBraintree);
Vue.use(Stripe);



const options = {
    pk: "pk_test_51IbgGqSDz4jcDQPyQYTalccm4SMoPTR0d4aGsKyaVFa6Rxj7YhZZJWCUPLSJkXhT3WNbxCpK6TnQo3ty9UeRq27l0061DZ5UM1",
    stripeAccount: "acct_1IbgGqSDz4jcDQPy",
    apiVersion: "2020-08-27",
    locale: "en",
};

Vue.use(StripePlugin, options);

Vue.config.productionTip = false;


/* eslint-disable no-new */
var app = new Vue({
    store: store,
    router,
    el: "#app",
    render: (h) => h(App),
});
export default app;